import { useTranslations } from '@vocab/react';
import {
  Actions,
  ButtonLink,
  IconNewWindow,
  Stack,
  Text,
} from 'braid-design-system';
import type { FC } from 'react';

import { TrackOnMount } from 'src/libs/Analytics';

import translations from './.vocab';

interface AdPerformanceDialogContentProps {
  link: string;
  onViewReportButtonClicked: () => void;
  trackAdPerformanceDialogDisplayed: () => void;
}

export const AdPerformanceDialogContent: FC<
  AdPerformanceDialogContentProps
> = ({
  link,
  onViewReportButtonClicked,
  trackAdPerformanceDialogDisplayed,
}) => {
  const { t } = useTranslations(translations);
  return (
    <TrackOnMount onMount={trackAdPerformanceDialogDisplayed}>
      <Stack space="large" align="center">
        <Text>{t('Your analytics report provides personalised tips.')}</Text>
        <Actions>
          <ButtonLink
            href={link}
            onClick={onViewReportButtonClicked}
            icon={<IconNewWindow />}
            tone="brandAccent"
            target="_blank"
          >
            {t('View report')}
          </ButtonLink>
        </Actions>
      </Stack>
    </TrackOnMount>
  );
};
